<template>
    <v-container>
        <v-layout wrap align-center justify-center>
            <v-flex xs12 sm12 md12 style="text-align: center" class="mt-4">
                <v-icon class="mb-5 display-4">mdi-alert-circle-outline</v-icon>
                <v-alert
                        :value="true"
                        type="error"
                        outline
                >
                    {{ msg }}
                </v-alert>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "ErrorLanding",
        props:{
            msg:String
        }

    }
</script>

<style scoped>

</style>